import { render, staticRenderFns } from "./DPView.vue?vue&type=template&id=7509c4c9&scoped=true&"
import script from "./DPView.vue?vue&type=script&lang=js&"
export * from "./DPView.vue?vue&type=script&lang=js&"
import style0 from "./DPView.vue?vue&type=style&index=0&id=7509c4c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7509c4c9",
  null
  
)

export default component.exports